// src/pages/Home.jsx
import React, { useState, useEffect } from "react";
import SeriesCard from "../components/SeriesCard";
import GenreFilter from "../components/GenreFilter";
import "../styles/styles.css";
import { getAllSeries } from "../utils/seriesUtils";

const Home = ({ user }) => {
  const [allSeries, setAllSeries] = useState([]);
  const [filteredSeries, setFilteredSeries] = useState([]);
  const [selectedGenres, setSelectedGenres] = useState([]);

  useEffect(() => {
    const seriesList = getAllSeries();
    setAllSeries(seriesList);
    setFilteredSeries(seriesList);
  }, []);

  useEffect(() => {
    if (selectedGenres.length === 0) {
      setFilteredSeries(allSeries);
    } else {
      const filtered = allSeries.filter((serie) =>
        selectedGenres.every((g) => serie.genre.includes(g))
      );
      setFilteredSeries(filtered);
    }
  }, [selectedGenres, allSeries]);

  // SERIES MÁS POPULARES para el Hero
  const popularSeries = [...allSeries].sort(
    (a, b) => b.popularity - a.popularity
  );
  const topSerie = popularSeries[0] || null;

  // Series más recientes para la sección inferior
  const recentSeries = [...allSeries]
    .sort((a, b) => new Date(b.releaseDate) - new Date(a.releaseDate))
    .slice(0, 4);

  return (
    <div className="home-container">
      {/* HERO/BANNER */}
      {topSerie && (
        <div
          className="hero-banner"
          style={{
            backgroundImage: `url(${topSerie.thumbnail})`,
          }}
        >
          <div className="hero-content">
            <h1 className="hero-title">{topSerie.title}</h1>
            <p className="hero-synopsis">
              {topSerie.synopsis.length > 150
                ? topSerie.synopsis.substring(0, 147) + "..."
                : topSerie.synopsis}
            </p>
            <button
              className="btn-primary"
              onClick={() => (window.location.href = `/series/${topSerie.id}`)}
            >
              Ver Ahora
            </button>
          </div>
          <div className="hero-overlay" />
        </div>
      )}

      {/* CONTENIDO DEBAJO DEL HERO */}
      <div className="content-wrapper">
        {/* FILTRO POR GÉNERO */}
        <GenreFilter
          genres={Array.from(new Set(allSeries.flatMap((s) => s.genre)))}
          selectedGenres={selectedGenres}
          setSelectedGenres={setSelectedGenres}
        />

        {/* GRID DE SERIES DISPONIBLES */}
        <section className="series-list-section">
          <h2>Series Disponibles</h2>
          {filteredSeries.length > 0 ? (
            <div className="series-grid">
              {filteredSeries.map((serie) => (
                <SeriesCard key={serie.id} series={serie} />
              ))}
            </div>
          ) : (
            <p style={{ color: "var(--color-text-secondary)" }}>
              No se encontraron series con los filtros seleccionados.
            </p>
          )}
        </section>

        {/* SERIES MÁS RECIENTES */}
        <section
          className="recent-popular-section"
          style={{ marginTop: "2rem" }}
        >
          <div className="recent-section" style={{ marginBottom: "2rem" }}>
            <h3
              style={{
                color: "var(--color-text)",
                fontSize: "1.5rem",
                marginBottom: "1rem",
              }}
            >
              Series Más Recientes
            </h3>
            <div className="series-grid">
              {recentSeries.map((serie) => (
                <SeriesCard key={serie.id} series={serie} />
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Home;